import * as S from './index.style'
import { DadosDespesasAcessorias, ValidacaoDadosDespesasAcessorias } from 'models/Viabilidade/DespesasAcessorias'
import Grid from 'components/Grid'
import { InputBaseComponentProps, TextField } from '@material-ui/core'
import { ElementType, useState } from 'react'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { helperTextErroCampoOpcional } from 'helpers/Constantes/Mensagens'

export type CartaoDadosDespesasAcessoriasProps = {
  tipoProjeto: string
  modeloNegocio: string
  dadosDespesasAcessorias: DadosDespesasAcessorias
  dadosDespesasAcessoriasHandler: (novoValor: DadosDespesasAcessorias) => void
}

const DespesasAcessorias: React.FC<CartaoDadosDespesasAcessoriasProps> = ({
  tipoProjeto,
  modeloNegocio,
  dadosDespesasAcessorias,
  dadosDespesasAcessoriasHandler
}) => {
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosDespesasAcessorias())
  const [valores, setValores] = useState(dadosDespesasAcessorias)

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>): Record<string, unknown> => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    return state
  }

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosDespesasAcessorias
    setValores(state)
    dadosDespesasAcessoriasHandler(state)
  }

  const validarItbiTerreno = () => {
    const erroItbiTerreno = mensagensErro.validarCampoPreenchidoValorDiferenteZero(valores.itbiTerreno, tipoProjeto, modeloNegocio)

    const validador = new ValidacaoDadosDespesasAcessorias(
      erroItbiTerreno,
      mensagensErro.escrituras,
      mensagensErro.realIntencionado,
      mensagensErro.corretagemProspeccao
    )

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarEscrituras = () => {
    const erroEscrituras = mensagensErro.validarCampoPreenchidoValorDiferenteZero(valores.escrituras, tipoProjeto, modeloNegocio)

    const validador = new ValidacaoDadosDespesasAcessorias(
      mensagensErro.itbiTerreno,
      erroEscrituras,
      mensagensErro.realIntencionado,
      mensagensErro.corretagemProspeccao
    )

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarRealIntencionado = () => {
    const erroRealIntencionado = mensagensErro.validarValorDiferenteZero(valores.realIntencionado)

    const validador = new ValidacaoDadosDespesasAcessorias(
      mensagensErro.itbiTerreno,
      mensagensErro.escrituras,
      erroRealIntencionado,
      mensagensErro.corretagemProspeccao
    )

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCorretagemProspeccao = () => {
    const erroCorretagemProspeccao = mensagensErro.validarValorDiferenteZero(valores.corretagemProspeccao)

    const validador = new ValidacaoDadosDespesasAcessorias(
      mensagensErro.itbiTerreno,
      mensagensErro.escrituras,
      mensagensErro.realIntencionado,
      erroCorretagemProspeccao
    )

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosDespesasAcessorias) => {
    const state = { ...valores } as DadosDespesasAcessorias

    state.valido = validador.validarTodosCampos(state)
    setValores(state)
    dadosDespesasAcessoriasHandler(state)
  }

  return (
    <S.Wrapper data-cy="sessaoDespesasAcessorias">
      <S.NomeSecao>Despesas Acessórias</S.NomeSecao>
      <Grid orientacao="column" gridTemplateColumns="repeat(4, 184px)" gridTemplateRow="1fr" gridGap="48px" margin="0">
        <div>
          <S.Label>ITBI Terreno (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            name="itbiTerreno"
            data-cy="campoItbiTerreno"
            value={valores.itbiTerreno}
            onChange={camposHandler}
            onBlur={validarItbiTerreno}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.itbiTerreno != ''}
            helperText={mensagensErro.itbiTerreno}
          />
        </div>
        <div>
          <S.Label>Escrituras (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            name="escrituras"
            data-cy="campoEscrituras"
            value={valores.escrituras}
            onChange={camposHandler}
            onBlur={validarEscrituras}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.escrituras != ''}
            helperText={mensagensErro.escrituras}
          />
        </div>
        <div>
          <S.Label>Real Intencionado (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            name="realIntencionado"
            data-cy="campoRealIntencionado"
            value={valores.realIntencionado}
            onChange={camposHandler}
            onBlur={validarRealIntencionado}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.realIntencionado != ''}
            helperText={helperTextErroCampoOpcional(mensagensErro.realIntencionado)}
          />
        </div>
        <div>
          <S.Label>Corretagem de Prospecção (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            name="corretagemProspeccao"
            data-cy="campoCorretagemProspeccao"
            value={valores.corretagemProspeccao}
            onChange={camposHandler}
            onBlur={validarCorretagemProspeccao}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.corretagemProspeccao != ''}
            helperText={helperTextErroCampoOpcional(mensagensErro.corretagemProspeccao)}
          />
        </div>
      </Grid>
    </S.Wrapper>
  )
}

export default DespesasAcessorias
